import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CustomerService } from '../customer.service';

@Injectable({
    providedIn: 'root'
})
export class SourceTypeService {

    private endpointPrefix = environment.apiUrl;

    constructor(private http: HttpClient, private customerService: CustomerService) { }

    getSourceTypes(customerId?: number, option: boolean = false) {
        if (customerId) {
            return this.http.get(`${this.endpointPrefix}/source-types/by-customer`, { params: { customerId: customerId, option: option } });
        }
        if (this.customerService.getIsJubooAgent()) {
            return this.http.get(`${this.endpointPrefix}/customers/0/source-types`, { params: { option: option } });
        }
        return this.http.get(`${this.endpointPrefix}/source-types`, { params: { option: option } });
    }

    getSourceTypesByBundleId(bundleId: number, customerId?: number) {
        let params: any = { bundleId };

        if (customerId) {
            params.customerId = customerId;
        }
        return this.http.get(
            `${this.endpointPrefix}/source-types/bundle`,
            { params }
        );
    }
}
